// DaBot Widget - Vanilla JS shell + lazily-loaded Svelte chat panel
import { DabotWidget } from './lib/Shell.js';

customElements.define('dabot-widget', DabotWidget);

// Expose version for debugging
window.DabotWidget = {
  version: '2.0.0'
};
